<script>
import baseList from "@/views/components/base/baseList.vue";
import { Tag, Button, RadioGroup, Radio } from "view-design";
// let customerId = window.localStorage.getItem("customerId")
// import config from "@/../config";''
import dayjs from "dayjs";
export default {
  extends: baseList,
  data() {
    return {
      table: {
        mname: "engineer",
        key: "id",
        url: {
          list: "/admin/system/maiUser/insListAll",
        },
        output: false,
      },
      menus: [

      ],
      filters: [
        // {
        //   label: "时间",
        //   KeyEnter: this.search,
        //   name: "createTime",
        //   value: "",
        //   type: "datetimerangemonth",
        // },
      ],
      tableCols: [
        {
          type: "index",
          title: "序号",
          width: 80,
          align: "center",
        },
        {
          title: "工程师",
          minWidth: 180,
          key: "nickName",
          align: "left",
          render: (h, p) => {
            let item = p.row;
            // console.log(item, 111111);
            return (
              <div onClick={() => this.toInfoList(item)} style="color:#4991ff;cursor: pointer;">
                {item.nickName}
              </div>
            );
          },
        },
      ],
      query: {
        // createTime: dayjs().format("YYYY-MM") + "-02",
      },
    };
  },
  created() {

  },
  methods: {
    toInfoList(item) {
      // let q = {
      //   maintainerId: item.userId
      // }
      window.localStorage.setItem('engineerQuery', item.userId)
      $utils.url.push({ name: "every_inspection_list" });
    }
  },
};
</script>

<style></style>
